// @ts-nocheck



import type RequestsController from '../requests';
import type { WialonApiSection } from '../requests';

export class Events {
  controller: WialonApiSection;

  constructor(controller: RequestsController) {
    this.controller = controller.getApiSection('events');
  }

  // проверяем изменения
  async checkUpdates() {
    return await this.controller.fetch('check_updates', {
      detalization: 3
    });
  }

  // подписываемся на изменения элементов
  async updateUnits(unitIds) {
    return await this.controller.fetch('update_units', {
      mode: 'add',
      units: unitIds.map((id) => ({
        id,
        detect: { '*': 0 }
      }))
    });
  }
}
